import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import type { ApiInstance, CategoryResult, CategoriesParams } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useCategories = (
  api: ApiInstance,
  searchParams: CategoriesParams,
  options?: CustomUseQueryOptions<CategoryResult>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(searchParams, true),
    queryKey: [queryKey, 'Categories', searchParams],
    queryFn: async () => {
      const { data } = await api.market.getCategories(searchParams);
      return data;
    },
  });
};
